"use client";

import { useState } from "react";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GaleriaWykonanychPrac() {
  const filters = ["Wszystkie Realizacje", "Dachy Płaskie", "Dachy Skośne", "Taras i Balkon", "Obiekty Przemysłowe", "Renowacje"];
  const [activeFilter, setActiveFilter] = useState("Wszystkie Realizacje");
  const projects = [{
    number: "HR-01",
    name: "Hydroizolacja dachu płaskiego",
    room: "Dachy Płaskie",
    location: "Pszczyna",
    year: "2024",
    span: "col-span-12 md:col-span-7",
    aspect: "aspect-[4/3]",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/dach_plaski_pszczyna.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/dach_plaski_pszczyna.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/dach_plaski_pszczyna.png-wvc-sizes"
  }, {
    number: "HR-02",
    name: "Renowacja dachu skośnego",
    room: "Dachy Skośne",
    location: "Śląsk",
    year: "2024",
    span: "col-span-12 md:col-span-5",
    aspect: "aspect-[3/4]",
    image: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/roof_leak_repair_expert.png?v=mau0nad8gxl",
    srcset: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/08384AB3-A744-4548-AF8A-41E3676C5915.png?v=pebo332xewm-wvc-srcset",
    sizes: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/08384AB3-A744-4548-AF8A-41E3676C5915.png?v=fgql4kxey9m-wvc-sizes"
  }, {
    number: "HR-03",
    name: "Hydroizolacja tarasu",
    room: "Taras i Balkon",
    location: "Małopolska",
    year: "2023",
    span: "col-span-12 md:col-span-6",
    aspect: "aspect-[1/1]",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/taras_hydroizolacja.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/taras_hydroizolacja.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/taras_hydroizolacja.png-wvc-sizes"
  }, {
    number: "HR-04",
    name: "Dach hali przemysłowej",
    room: "Obiekty Przemysłowe",
    location: "Opolskie",
    year: "2023",
    span: "col-span-12 md:col-span-6",
    aspect: "aspect-[4/3]",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/dach_hala_przemyslowa.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/dach_hala_przemyslowa.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/dach_hala_przemyslowa.png-wvc-sizes"
  }, {
    number: "HR-05",
    name: "Uszczelnienie papy",
    room: "Renowacje",
    location: "Pszczyna",
    year: "2023",
    span: "col-span-12 md:col-span-4",
    aspect: "aspect-[3/4]",
    image: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/renowacja_papa_slask.png?v=b6qekvinekb",
    srcset: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/renowacja_papa_slask.png?v=lvomtqiyc2-wvc-srcset",
    sizes: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/renowacja_papa_slask.png?v=baaaokb0du-wvc-sizes"
  }, {
    number: "HR-06",
    name: "Technical floor waterproofing with polyurethane spray membrane",
    room: "Renowacje",
    location: "Czechy",
    year: "2023",
    span: "col-span-12 md:col-span-8",
    aspect: "aspect-[16/10]",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/floor_waterproofing_polyurethane.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/floor_waterproofing_polyurethane.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/floor_waterproofing_polyurethane.png-wvc-sizes"
  }];
  const spreadImage = {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/technologia_natryskowa.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/technologia_natryskowa.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/technologia_natryskowa.png-wvc-sizes",
    caption: "Precyzyjna aplikacja bezspoinowej membrany natryskowej. Trwałość, odporność na UV i całkowita szczelność w każdych warunkach."
  };
  const projects2 = [{
    number: "HR-07",
    name: "Hydroizolacja balkonu",
    room: "Taras i Balkon",
    location: "Śląsk",
    year: "2022",
    span: "col-span-12 md:col-span-7",
    aspect: "aspect-[4/3]",
    image: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/uszczelnianie.png?v=3zac5wzh2y1",
    srcset: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/uszczelnianie.png?v=6nqxcuxm8a3-wvc-srcset",
    sizes: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/uszczelnianie.png?v=vlrt2wr9fkc-wvc-sizes"
  }, {
    number: "HR-08",
    name: "Naprawa przecieków",
    room: "Renowacje",
    location: "Pszczyna",
    year: "2022",
    span: "col-span-12 md:col-span-5",
    aspect: "aspect-[3/4]",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/flat_roof_spray_polyurethane.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/flat_roof_spray_polyurethane.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/flat_roof_spray_polyurethane.png-wvc-sizes"
  }];
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="672" id="galeria-wykonanych-prac" className="bg-background text-foreground pt-[200px] pb-32 px-6 md:px-12 lg:px-16 overflow-hidden">
      <div ref={headerRef} className={`grid grid-cols-12 gap-8 mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="col-span-12 md:col-span-9">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase mb-8 text-blue-600">
            HydroRoof / Realizacje
          </p>
          <h1 className="font-default font-bold text-foreground leading-[0.95] tracking-tight !text-8xl" style={{
          fontSize: "clamp(4rem, 9vw, 8rem)"
        }}>Nasze realizacje</h1>
          <p className="font-default text-muted-foreground text-xl md:text-2xl mt-8 max-w-2xl leading-relaxed">
            Profesjonalna hydroizolacja i renowacja dachów. Zobacz, jak przywracamy szczelność i trwałość obiektom naszych klientów.
          </p>
        </div>
        <div className="col-span-12 md:col-span-3 md:text-right md:pt-4">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-muted-foreground">
            Wybrane projekty
          </p>
        </div>
      </div>

      <div className="border-y border-border mb-16 md:mb-24">
        <div className="overflow-x-auto scrollbar-hide -mx-6 md:mx-0">
          <div className="flex items-center gap-0 px-6 md:px-0 min-w-max md:min-w-0 md:flex-wrap">
            {filters.map((filter, i) => <div key={filter} data-index={i} className="flex items-center">
                <Button variant="ghost" onClick={() => setActiveFilter(filter)} className={`relative font-default text-sm tracking-wide py-6 px-5 h-auto rounded-none hover:bg-transparent hover:text-blue-600 transition-colors duration-300 ${activeFilter === filter ? "text-blue-600" : "text-muted-foreground"}`}>
                  {filter}
                  <span className={`absolute bottom-4 left-5 right-5 h-px transition-all duration-300 ease-out ${activeFilter === filter ? "scale-x-100" : "scale-x-0"}`} style={{
                backgroundColor: "var(--ring)",
                transformOrigin: "left"
              }} />
                </Button>
                {i < filters.length - 1 && <span className="h-4 w-px bg-border" aria-hidden="true" />}
              </div>)}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-x-6 gap-y-20 md:gap-y-28 mb-24 md:mb-32">
        {projects.map((project, i) => <article key={project.number} data-index={i} className={`${project.span} group cursor-pointer`}>
            <div className={`relative overflow-hidden rounded-lg ${project.aspect}`}>
              <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-[1.04]" />
              <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <ArrowUpRight className="h-5 w-5 text-blue-600" strokeWidth={1.25} />
              </div>
            </div>
            <div className="mt-6 transition-opacity duration-500">
              <p className="font-mono text-[11px] tabular-nums tracking-wider mb-3 text-blue-600">
                {project.number}
              </p>
              <h3 className="font-default font-semibold text-foreground text-2xl md:text-[1.5rem] leading-tight mb-3">
                {project.name}
              </h3>
              <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-muted-foreground">
                {project.room} · {project.location} · {project.year}
              </p>
            </div>
          </article>)}
      </div>

      <div className="mb-24 md:mb-32 -mx-6 md:-mx-12 lg:-mx-16">
        <div className="relative w-full aspect-[21/9] overflow-hidden">
          <img src={spreadImage.image} data-wvc-srcset={spreadImage.srcset} data-wvc-sizes={spreadImage.sizes} alt="Technologia natryskowa HydroRoof" loading="lazy" decoding="async" className="w-full h-full object-cover" />
        </div>
        <div className="px-6 md:px-12 lg:px-16 mt-8">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 md:col-span-2">
              <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-blue-600">
                Technologia
              </p>
            </div>
            <div className="col-span-12 md:col-span-8">
              <p className="font-default text-foreground text-xl md:text-2xl leading-relaxed">
                {spreadImage.caption}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-x-6 gap-y-20 md:gap-y-28 mb-24">
        {projects2.map((project, i) => <article key={project.number} data-index={i} className={`${project.span} group cursor-pointer`}>
            <div className={`relative overflow-hidden rounded-lg ${project.aspect}`}>
              <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-[1.04]" />
              <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <ArrowUpRight className="h-5 w-5 text-blue-600" strokeWidth={1.25} />
              </div>
            </div>
            <div className="mt-6">
              <p className="font-mono text-[11px] tabular-nums tracking-wider mb-3 text-blue-600">
                {project.number}
              </p>
              <h3 className="font-default font-semibold text-foreground text-2xl md:text-[1.5rem] leading-tight mb-3">
                {project.name}
              </h3>
              <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-muted-foreground">
                {project.room} · {project.location} · {project.year}
              </p>
            </div>
          </article>)}
      </div>

      <div className="hidden justify-center pt-12">
        <Button variant="ghost" className="group font-default text-base text-foreground hover:bg-transparent hover:text-foreground px-0 h-auto py-3">
          <span className="relative">
            Zobacz więcej realizacji
            <span className="absolute -bottom-1 left-0 right-0 h-px transition-transform duration-500 ease-out origin-left scale-x-100 group-hover:scale-x-0 bg-border" />
            <span className="absolute -bottom-1 left-0 right-0 h-px transition-transform duration-500 ease-out origin-right scale-x-0 group-hover:scale-x-100 bg-blue-600" />
          </span>
          <ArrowRight className="ml-3 h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.5} />
        </Button>
      </div>
    </section>;
}